import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const SET_LOADING = "saga/challengerConversion/SET_LOADING";
export const SET_DATES = "saga/challengerConversion/SET_DATES";
export const UPDATE_DATES = "saga/challengerConversion/UPDATE_DATES";
export const CLEAR_DATA = "saga/challengerConversion/CLEAR_DATA";
export const DISPLAY_ERROR = "saga/challengerConversion/DISPLAY_ERROR";
export const SET_CHART_LOADING = "saga/challengerConversion/SET_CHART_LOADING";
export const UPDATE_CUSTOM_RANGE = "saga/challengerConversion/UPDATE_CUSTOM_RANGE";
export const FETCH_CURRENT_USER = "saga/challengerConversion/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/challengerConversion/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTER_DATA_SUCCESS = "saga/challengerConversion/FETCH_FILTER_DATA_SUCCESS";
export const FETCH_OFFERS_DATA_SUCCESS = "saga/challengerConversion/FETCH_OFFERS_DATA_SUCCESS";
export const UPDATE_FILTERS = "saga/challengerConversion/UPDATE_FILTERS";
export const UPDATE_FILTERS_SUCCESS = "saga/challengerConversion/UPDATE_FILTERS_SUCCESS";
export const FETCH_DATA_AND_FILTERS = "sagas/challengerConversion/FETCH_DATA_AND_FILTERS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  fetchDataAndFilters: createAction(FETCH_DATA_AND_FILTERS),
  updateDates: createAction(UPDATE_DATES),
  updateFilters: createAction(UPDATE_FILTERS),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE)
};

export default function* watchChallengerConversion() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_DATA_AND_FILTERS, getDataAndFilters);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: CLEAR_DATA, payload: true });
  const { calendarEndDate } = payload;
  let endDate, startDate;
  if (payload.updateOnlyChart) yield offersData();
  else {
    yield put({ type: SET_LOADING, payload: true });
    startDate = moment(calendarEndDate).startOf("month").format(API_DATE_FORMAT);
    endDate = calendarEndDate;

    yield put({ type: SET_DATES, payload: { startDate, endDate } });
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload });

    yield getFilterData();

    try {
      yield offersData();
      yield put({ type: SET_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  }
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => {
    return state.commonReducer.commonProps;
  });
  const {
    currentUser: { calendarEndDate },
    selectedRequestDates: { startDate, endDate }
  } = yield select((state) => state.challengerConversion);

  return { organization_id, short_url, calendarEndDate, start_date: startDate, end_date: endDate };
}

function* offersData() {
  const { organization_id, short_url, start_date, end_date } = yield getCommonApiParams();
  const commonParams = {
    organization_id,
    short_url,
    start_date,
    end_date
  };

  yield put({ type: SET_CHART_LOADING, payload: true });

  let selectedFilters = yield select((state) => state.challengerConversion.selectedFilters);
  let allSagas = [];

  if (selectedFilters.length === 0)
    yield put({
      type: DISPLAY_ERROR
    });
  else {
    for (let i = 0; i < selectedFilters.length; i++) {
      allSagas.push(getOffersData(commonParams, selectedFilters[i].id));
    }
    try {
      yield all(allSagas);
      yield put({ type: SET_CHART_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  }
}

export function* getDataAndFilters() {
  yield getFilterData(true);
  try {
    yield put({ type: CLEAR_DATA, payload: true });
    yield offersData();
  } catch (error) {
    console.error(error);
  }
}

export function* getFilterData(usePrevSelectedFilters) {
  const { organization_id, short_url, start_date, end_date } = yield getCommonApiParams();

  const tableDataResponse = yield call(
    axios.get,
    queryParams.apiVersion + "pages/packages/challenger_conversion_chart/get_conversion_filters",
    { params: { organization_id, short_url, start_date, end_date } }
  );

  yield put({
    type: FETCH_FILTER_DATA_SUCCESS,
    payload: { data: tableDataResponse.data, usePrevSelectedFilters }
  });
}

export function* getOffersData(commonParams, offerId) {
  try {
    const tableDataResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/packages/challenger_conversion_chart/get_challenger_conversion_values",
      { params: { ...commonParams, id: offerId } }
    );

    yield put({ type: FETCH_OFFERS_DATA_SUCCESS, payload: tableDataResponse.data });
  } catch (error) {
    console.error(error);
  }
}
